import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Tamaños del prototipo validado, en px y no con las variantes del tema (que escalan a partir de
 * `fontSize: 13` y quedan más pequeñas): etiqueta 14/500, contador, ayuda y subetiqueta 12/400.
 */
export const labelSx = { fontSize: '14px', fontWeight: 500, lineHeight: 1.4, color: 'text.primary' };
export const smallTextSx = { fontSize: '12px', fontWeight: 400, lineHeight: 1.4 };

/**
 * «x/max», en rojo si se pasa (solo puede pasar con un texto ya guardado más largo). Con `warning`,
 * en naranja: se pasa, pero no bloquea (traducción automática sin tocar).
 */
export const CharCounter = ({ count, max, warning = false }) => {
    const over = count > max;
    return (
        <Typography
            component="span"
            data-testid="char-counter"
            color={over ? (warning ? 'warning.dark' : 'error') : 'text.secondary'}
            sx={{ ...smallTextSx, fontWeight: over ? 600 : 400, whiteSpace: 'nowrap' }}
        >
            {count}/{max}
        </Typography>
    );
};

/** Etiqueta de campo con el contador a la derecha, en la misma línea, como en el prototipo. */
export const FieldLabel = ({ htmlFor, label, count, max, warning }) => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1, mb: 0.75 }}>
        <Typography component={htmlFor ? 'label' : 'span'} htmlFor={htmlFor} sx={labelSx}>
            {label}
        </Typography>
        {max !== undefined && <CharCounter count={count} max={max} warning={warning} />}
    </Box>
);

/** Texto de ayuda bajo un campo. */
export const HelpText = ({ children, color = 'text.secondary', ...rest }) => (
    <Typography component="span" color={color} sx={{ ...smallTextSx, display: 'block', mt: 0.75 }} {...rest}>
        {children}
    </Typography>
);

export default CharCounter;
